// React imports.
import React, { Component } from "react";

// App imports.
//import Assessment5MainTable from "./Assessment5MainTable";

import { Assessment1FuelStatusEnum } from "../state";
import { Assessment2FuelStatusEnum } from "../state";
import { Assessment5StepsEnum } from "../state";
import { Assessment5SedsStatusEnum } from "../state";
import { Assessment3HHDataReceivedStatusEnum } from "../state";
import Assessment1MainTable from "./Assessment1MainTable";
import Assessment5VendorsReportedTable from "./Assessment5VendorsReportedTable";
import Assessment5AssistedHouseholdsTable from "./Assessment5AssistedHouseholdsTable";
import TableLegend from "./TableLegend";

const Assessment5 = ({ state }) => (
      <div>
          {state.CurrentAssessementStepIndex == Assessment5StepsEnum.EnterDataAverageExpenditures &&
              <div>
                  <p><strong>Assessment 1</strong></p>

                  Assessment 1 checks your low-income average main heating expenditure data against the average main heating
                  expenditure data found within the EIA’s State Energy Data System (SEDS). 

                  <br/><br/>
                  If the PM data for the year you are trying to evaluate is available in the LIHEAP Data Warehouse, then it
                  has been auto populated in the appropriate column below. If you are trying to evaluate a year for which data
                  has not yet been added to the Data Warehouse, you will need to manually enter the calculated average
                  expenditures for each fuel type, which can be found in Section V, Part B, Line 4 of your Performance Data Form.

                  <br/><br/>
                  <Assessment1MainTable fieldChangeHandler={state.assessment5FieldChangeHandler}  holder={state.Assessment5FuelTypesStatus} step={state.Assessment5Steps[state.CurrentAssessementStepIndex]} state={state} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment5StepsEnum.PercentOfSeds &&
              <div>
                  <p><strong>Assessment 1</strong></p>

                  Assessment 1 checks your low-income average main heating expenditure data against the average main heating
                  expenditure data found within the EIA’s State Energy Data System (SEDS). 

                  <br/><br/>
                  If the PM data for the year you are trying to evaluate is available in the LIHEAP Data Warehouse, then it
                  has been auto populated in the appropriate column below. If you are trying to evaluate a year for which data
                  has not yet been added to the Data Warehouse, you will need to manually enter the calculated average
                  expenditures for each fuel type, which can be found in Section V, Part B, Line 4 of your Performance Data Form.

                  <br/><br/>
                  <Assessment1MainTable fieldChangeHandler={state.assessment5FieldChangeHandler}  holder={state.Assessment5FuelTypesStatus} step={state.Assessment5Steps[state.CurrentAssessementStepIndex]} state={state} />
                  <br />


                  {(state.Assessment5FuelTypesStatus.assessment1OverallStatus === Assessment5SedsStatusEnum.OutOfRange)
                      &&
                        <span>
                            <strong>Potential issue present! Follow-up required!</strong><br/>
                            Please conduct a full run-through of Assessment #1 to learn more about this potential
                            issue and ways you can address it.
                        </span>}
                  {(state.Assessment5FuelTypesStatus.assessment1OverallStatus === Assessment5SedsStatusEnum.InRangeNoIssues)
                        && <span><strong>Looks good! No action needed!</strong></span>}
                  {(state.Assessment5FuelTypesStatus.assessment1OverallStatus === Assessment5SedsStatusEnum.NoSEDSData)
                      &&
                        <span>
                            <strong>N/A</strong><br/>
                            SEDS data missing for one or more fuels.  Not able to evaluate all fuels.
                        </span>}
                  {(state.Assessment5FuelTypesStatus.assessment1OverallStatus === Assessment5SedsStatusEnum.ZeroAverageExpenditure)
                      &&
                        <span>
                            <strong>Potential issue present! Follow-up required!</strong><br/>
                            You reported zero average expenditures for one or more fuels.  You should verify that
                            this is correct and you may want to conduct a full run-through of Assessment #1.
                        </span>}

              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment5StepsEnum.TotalVendors &&
              <div>
                  <p><strong>Assessment 2</strong></p>
                  Assessment 2 checks that you received data from the required number of vendors for each fuel type. 

                  <br/><br/>
                  For each fuel type in the table below, please enter the total number of vendors serving LIHEAP
                  clients in your state/territory, as well as the number of vendors who ultimately provided you
                  with main heating expenditure data. This information is NOT reported in your annual Performance
                  Measures Form, so you will need to provide it from your own records.

                  <br/><br/>
                  <Assessment5VendorsReportedTable fieldChangeHandler={state.assessment5FieldChangeHandler} holder={state.Assessment5FuelTypesStatus} step={state.Assessment5Steps[state.CurrentAssessementStepIndex]} state={state} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment5StepsEnum.VendorsReceived &&
              <div>
                  <p><strong>Assessment 2</strong></p>
                  Assessment 2 checks that you received data from the required number of vendors for each fuel type. 
                  <br/><br/>
                  For each fuel type in the table below, please enter the total number of vendors serving LIHEAP
                  clients in your state/territory, as well as the number of vendors who ultimately provided you
                  with main heating expenditure data. This information is NOT reported in your annual Performance
                  Measures Form, so you will need to provide it from your own records.
                  <br/><br/>
                  <Assessment5VendorsReportedTable fieldChangeHandler={state.assessment5FieldChangeHandler} holder={state.Assessment5FuelTypesStatus} step={state.Assessment5Steps[state.CurrentAssessementStepIndex]} state={state} />
                  <br />
                  <br />
                  {((state.Assessment5FuelTypesStatus.Electric.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.OverMinNoIssues
                  && state.Assessment5FuelTypesStatus.Electric.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.UnderMinNoIssues)
                  ||(state.Assessment5FuelTypesStatus.NaturalGas.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.OverMinNoIssues
                  && state.Assessment5FuelTypesStatus.NaturalGas.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.UnderMinNoIssues)
                  ||(state.Assessment5FuelTypesStatus.FuelOil.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.OverMinNoIssues
                  && state.Assessment5FuelTypesStatus.FuelOil.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.UnderMinNoIssues)
                  ||(state.Assessment5FuelTypesStatus.Propane.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.OverMinNoIssues
                  && state.Assessment5FuelTypesStatus.Propane.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.UnderMinNoIssues))
                    && <span>
                        <strong>Potential issue present! Follow-up required!</strong><br/>
                        Please conduct a full run-through of Assessment #2 to learn more about this potential
                        issue and ways you can address it.
                    </span>
                  }
                  {((state.Assessment5FuelTypesStatus.Electric.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.OverMinNoIssues
                        || state.Assessment5FuelTypesStatus.Electric.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.UnderMinNoIssues)
                    && (state.Assessment5FuelTypesStatus.NaturalGas.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.OverMinNoIssues
                        || state.Assessment5FuelTypesStatus.NaturalGas.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.UnderMinNoIssues)
                    && (state.Assessment5FuelTypesStatus.FuelOil.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.UnderMinNoIssues
                        ||state.Assessment5FuelTypesStatus.FuelOil.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.OverMinNoIssues)
                    &&(state.Assessment5FuelTypesStatus.Propane.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.OverMinNoIssues
                        || state.Assessment5FuelTypesStatus.Propane.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.UnderMinNoIssues))
                    && <span><strong>Looks good! No action needed!</strong></span>
                  }
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment5StepsEnum.AssistedHouseholds &&
              <div>
                  <p><strong>Assessment 3</strong></p>
                  Assessment 3 checks the number of households for whom you received main heating data against your total number of assisted households. 
                  <br/><br/>
                  Please enter the number of households for whom you received 12 consecutive months of main heating expenditure data in the table below. Please note that your Performance Data Form asks for the number of households for whom 12 months of consecutive billing data were collected for both main heating fuel and electricity. However, for the purposes of this assessment we are only concerned with the number of households for whom main heating fuel data was collected, so you will need to report this information from your own records.
                  <br/><br/>
                  <Assessment5AssistedHouseholdsTable  state={state} />
                  
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment5StepsEnum.NumHouseholdsDataCollectedOverview &&
              <div>
                  <p><strong>Assessment 3</strong></p>
                  Assessment 3 checks the number of households for whom you received main heating data against your total number of assisted households. 
                  <br/><br/>
                  Please enter the number of households for whom you received 12 consecutive months of main heating expenditure data in the table below. Please note that your Performance Data Form asks for the number of households for whom 12 months of consecutive billing data were collected for both main heating fuel and electricity. However, for the purposes of this assessment we are only concerned with the number of households for whom main heating fuel data was collected, so you will need to report this information from your own records.
                  <br/><br/>
                  <Assessment5AssistedHouseholdsTable  state={state} />
                  <br />
                  {(state.Assessment5FuelTypesStatus.Electric.dataReceivedStatus === Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                    ||state.Assessment5FuelTypesStatus.NaturalGas.dataReceivedStatus === Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                    ||state.Assessment5FuelTypesStatus.FuelOil.dataReceivedStatus === Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                    ||state.Assessment5FuelTypesStatus.Propane.dataReceivedStatus === Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                    )
                      &&
                        <span>
                            <strong>Potential issue present! Follow-up required!</strong><br/>
                            Please conduct a full run-through of Assessment #3 to learn more about this potential
                            issue and ways you can address it.
                        </span>}
                  {(state.Assessment5FuelTypesStatus.Electric.dataReceivedStatus != Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                    &&state.Assessment5FuelTypesStatus.NaturalGas.dataReceivedStatus != Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                    &&state.Assessment5FuelTypesStatus.FuelOil.dataReceivedStatus != Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                    &&state.Assessment5FuelTypesStatus.Propane.dataReceivedStatus != Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                    )
                        && <span><strong>Looks good! No action needed!</strong></span>}
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment5StepsEnum.checkEntry &&
              <div>
              <p><strong>Assessment 4</strong></p>
              Assessment #4 helps you evaluate the data checking routines that you have in place. Please answer the questions below.
              <br/><br/>
              <ol start={1}>
                  <li>
                      Do you have checks in place to examine whether agencies are collecting heating vendor information for every client? 
                      <br/>
                      <label>
                          <input type="radio"
                              name="checksCollectVendorInfoFlag"
                              id="checksCollectVendorInfoFlag_true"
                              value="true"
                              checked={state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === true}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checksCollectVendorInfoFlag"
                              id="checksCollectVendorInfoFlag_false"
                              value="false"
                              checked={state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === false}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === true
                        && <span><strong>Good!</strong></span>}
                      {state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === false
                        && <span>
                              <strong>Requires followup.</strong>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                  <li>
                      Do you have checks in place to review the data submitted by vendors and identify potential errors? 
                      <br/>
                      <label>
                          <input type="radio"
                              name="checksReviewDataSubmittedFlag"
                              id="checksReviewDataSubmittedFlag_true"
                              value="true"
                              checked={state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === true}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checksReviewDataSubmittedFlag"
                              id="checksReviewDataSubmittedFlag_false"
                              value="false"
                              checked={state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === false}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === true
                        && <span><strong>Good!</strong></span>}
                      {state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === false
                        && <span>
                              <strong>Requires followup.</strong>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                  <li>
                      Do you have procedures in place for reviewing and resolving the findings from your reliability checks?
                      <br/>
                      <label>
                          <input type="radio"
                              name="procedureReviewFindingsFlag"
                              id="procedureReviewFindingsFlag_true"
                              value="true"
                              checked={state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === true}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="procedureReviewFindingsFlag"
                              id="procedureReviewFindingsFlag_false"
                              value="false"
                              checked={state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === false}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === true
                        && <span><strong>Good!</strong></span>}
                      {state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === false
                        && <span>
                              <strong>Requires followup.</strong>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                  <li>
                      Do you have procedures in place for assessing the effectiveness of your checks and making changes when necessary?
                      <br/>
                      <label>
                          <input type="radio"
                              name="procedureAssessEffectivenessFlag"
                              id="procedureAssessEffectivenessFlag_true"
                              value="true"
                              checked={state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === true}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="procedureAssessEffectivenessFlag"
                              id="procedureAssessEffectivenessFlag_false"
                              value="false"
                              checked={state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === false}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === true
                        && <span><strong>Good!</strong></span>}
                      {state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === false
                        && <span>
                              <strong>Requires followup.</strong>
                              <br/>
                          </span>}
                      <br/>  
                  </li>

              </ol>
          </div>}
          {state.CurrentAssessementStepIndex == Assessment5StepsEnum.checkResult &&
              <div>
              <p><strong>Assessment 4</strong></p>
              Assessment #4 helps you evaluate the data checking routines that you have in place. Please answer the questions below.
              <br/><br/>
              <ol start={1}>
                  <li>
                      Do you have checks in place to examine whether agencies are collecting heating vendor information for every client? 
                      <br/>
                      <label>
                          <input type="radio"
                              name="checksCollectVendorInfoFlag"
                              id="checksCollectVendorInfoFlag_true"
                              value="true"
                              checked={state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === true}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checksCollectVendorInfoFlag"
                              id="checksCollectVendorInfoFlag_false"
                              value="false"
                              checked={state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === false}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === true
                        && <span><strong>Good!</strong></span>}
                      {state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === false
                        && <span>
                              <strong>Requires followup.</strong>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                  <li>
                      Do you have checks in place to review the data submitted by vendors and identify potential errors? 
                      <br/>
                      <label>
                          <input type="radio"
                              name="checksReviewDataSubmittedFlag"
                              id="checksReviewDataSubmittedFlag_true"
                              value="true"
                              checked={state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === true}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checksReviewDataSubmittedFlag"
                              id="checksReviewDataSubmittedFlag_false"
                              value="false"
                              checked={state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === false}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === true
                        && <span><strong>Good!</strong></span>}
                      {state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === false
                        && <span>
                              <strong>Requires followup.</strong>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                  <li>
                      Do you have procedures in place for reviewing and resolving the findings from your reliability checks?
                      <br/>
                      <label>
                          <input type="radio"
                              name="procedureReviewFindingsFlag"
                              id="procedureReviewFindingsFlag_true"
                              value="true"
                              checked={state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === true}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="procedureReviewFindingsFlag"
                              id="procedureReviewFindingsFlag_false"
                              value="false"
                              checked={state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === false}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === true
                        && <span><strong>Good!</strong></span>}
                      {state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === false
                        && <span>
                              <strong>Requires followup.</strong>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                  <li>
                      Do you have procedures in place for assessing the effectiveness of your checks and making changes when necessary?
                      <br/>
                      <label>
                          <input type="radio"
                              name="procedureAssessEffectivenessFlag"
                              id="procedureAssessEffectivenessFlag_true"
                              value="true"
                              checked={state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === true}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="procedureAssessEffectivenessFlag"
                              id="procedureAssessEffectivenessFlag_false"
                              value="false"
                              checked={state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === false}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === true
                        && <span><strong>Good!</strong></span>}
                      {state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === false
                        && <span>
                              <strong>Requires followup.</strong>
                              <br/>
                          </span>}
                      <br/>  
                  </li>

              </ol>
              {(state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === false
                    ||state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === false
                    ||state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === false
                    ||state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === false
                    )
                      &&
                        <span>
                            <strong>Potential issue present! Follow-up required!</strong><br/>
                            Please conduct a full run-through of Assessment #4 to learn more about this potential
                            issue and ways you can address it.
                        </span>}
                  {(state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === true
                    &&state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === true
                    &&state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === true
                    &&state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === true
                    )
                        && <span><strong>Looks good! No action needed!</strong></span>}

          </div>}

          {state.CurrentAssessementStepIndex == Assessment5StepsEnum.resultsOverview &&
              <div>
              <p><strong>Overview of Results</strong></p>
              Based on your responses to the 4 screeners you should prioritize the following detailed assessments:
              <ul>
                  {(state.Assessment5FuelTypesStatus.assessment1OverallStatus === Assessment5SedsStatusEnum.OutOfRange
                    ||state.Assessment5FuelTypesStatus.assessment1OverallStatus === Assessment5SedsStatusEnum.ZeroAverageExpenditure
                    )
                      &&<li>Assessment #1</li>}

                  {((state.Assessment5FuelTypesStatus.Electric.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.OverMinNoIssues
                    && state.Assessment5FuelTypesStatus.Electric.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.UnderMinNoIssues)
                    ||(state.Assessment5FuelTypesStatus.NaturalGas.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.OverMinNoIssues
                    && state.Assessment5FuelTypesStatus.NaturalGas.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.UnderMinNoIssues)
                    ||(state.Assessment5FuelTypesStatus.FuelOil.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.OverMinNoIssues
                    && state.Assessment5FuelTypesStatus.FuelOil.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.UnderMinNoIssues)
                    ||(state.Assessment5FuelTypesStatus.Propane.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.OverMinNoIssues
                    && state.Assessment5FuelTypesStatus.Propane.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.UnderMinNoIssues))
                        &&<li>Assessment #2</li>}
                  {(state.Assessment5FuelTypesStatus.Electric.dataReceivedStatus === Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                    ||state.Assessment5FuelTypesStatus.NaturalGas.dataReceivedStatus === Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                    ||state.Assessment5FuelTypesStatus.FuelOil.dataReceivedStatus === Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                    ||state.Assessment5FuelTypesStatus.Propane.dataReceivedStatus === Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                    )
                      &&<li>Assessment #3</li>}
                  {(state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === false
                    ||state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === false
                    ||state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === false
                    ||state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === false
                    )
                      &&<li>Assessment #4</li>}
              </ul>
              <br/><br/>
              <h2>Assessment 1</h2>
              <Assessment1MainTable fieldChangeHandler={state.assessment5FieldChangeHandler}  holder={state.Assessment5FuelTypesStatus} step={state.Assessment5Steps[state.CurrentAssessementStepIndex]} state={state} />
              <br />

              {(state.Assessment5FuelTypesStatus.assessment1OverallStatus === Assessment5SedsStatusEnum.OutOfRange)
                  &&
                    <span>
                        <strong>Potential issue present! Follow-up required!</strong><br/>
                        Please conduct a full run-through of Assessment #1 to learn more about this potential
                        issue and ways you can address it.
                    </span>
              }
              {(state.Assessment5FuelTypesStatus.assessment1OverallStatus === Assessment5SedsStatusEnum.InRangeNoIssues)
                    && <span><strong>Looks good! No action needed!</strong></span>
              }
              {(state.Assessment5FuelTypesStatus.assessment1OverallStatus === Assessment5SedsStatusEnum.NoSEDSData)
                  &&
                    <span>
                        <strong>N/A</strong><br/>
                        SEDS data missing for one or more fuels.  Not able to evaluate all fuels.
                    </span>
              }
              {(state.Assessment5FuelTypesStatus.assessment1OverallStatus === Assessment5SedsStatusEnum.ZeroAverageExpenditure)
                  &&
                    <span>
                        <strong>Potential issue present! Follow-up required!</strong><br/>
                        You reported zero average expenditures for one or more fuels.  You should verify that
                        this is correct and you may want to conduct a full run-through of Assessment #1.
                    </span>
              }
              <br/><br/>
              <h2>Assessment 2</h2>
              <Assessment5VendorsReportedTable fieldChangeHandler={state.assessment5FieldChangeHandler} holder={state.Assessment5FuelTypesStatus} step={state.Assessment5Steps[state.CurrentAssessementStepIndex]} state={state} />
              <br />
              <br />
              {((state.Assessment5FuelTypesStatus.Electric.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.OverMinNoIssues
                  && state.Assessment5FuelTypesStatus.Electric.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.UnderMinNoIssues)
                  ||(state.Assessment5FuelTypesStatus.NaturalGas.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.OverMinNoIssues
                  && state.Assessment5FuelTypesStatus.NaturalGas.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.UnderMinNoIssues)
                  ||(state.Assessment5FuelTypesStatus.FuelOil.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.OverMinNoIssues
                  && state.Assessment5FuelTypesStatus.FuelOil.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.UnderMinNoIssues)
                  ||(state.Assessment5FuelTypesStatus.Propane.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.OverMinNoIssues
                  && state.Assessment5FuelTypesStatus.Propane.vendorsSubmittingDataStatus != Assessment2FuelStatusEnum.UnderMinNoIssues))
                    && <span>
                        <strong>Potential issue present! Follow-up required!</strong><br/>
                        Please conduct a full run-through of Assessment #2 to learn more about this potential
                        issue and ways you can address it.
                    </span>
              }


                {((state.Assessment5FuelTypesStatus.Electric.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.OverMinNoIssues
                      || state.Assessment5FuelTypesStatus.Electric.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.UnderMinNoIssues)
                  && (state.Assessment5FuelTypesStatus.NaturalGas.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.OverMinNoIssues
                      || state.Assessment5FuelTypesStatus.NaturalGas.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.UnderMinNoIssues)
                  && (state.Assessment5FuelTypesStatus.FuelOil.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.UnderMinNoIssues
                      ||state.Assessment5FuelTypesStatus.FuelOil.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.OverMinNoIssues)
                  &&(state.Assessment5FuelTypesStatus.Propane.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.OverMinNoIssues
                      || state.Assessment5FuelTypesStatus.Propane.vendorsSubmittingDataStatus === Assessment2FuelStatusEnum.UnderMinNoIssues))
                  && <span><strong>Looks good! No action needed!</strong></span>
              }
              <br/><br/>
              <h2>Assessment 3</h2>
              <Assessment5AssistedHouseholdsTable  state={state} />
              <br />
              {(state.Assessment5FuelTypesStatus.Electric.dataReceivedStatus === Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                ||state.Assessment5FuelTypesStatus.NaturalGas.dataReceivedStatus === Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                ||state.Assessment5FuelTypesStatus.FuelOil.dataReceivedStatus === Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                ||state.Assessment5FuelTypesStatus.Propane.dataReceivedStatus === Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                )
                  &&
                    <span>
                        <strong>Potential issue present! Follow-up required!</strong><br/>
                        Please conduct a full run-through of Assessment #3 to learn more about this potential
                        issue and ways you can address it.
                    </span>}
              {(state.Assessment5FuelTypesStatus.Electric.dataReceivedStatus != Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                &&state.Assessment5FuelTypesStatus.NaturalGas.dataReceivedStatus != Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                &&state.Assessment5FuelTypesStatus.FuelOil.dataReceivedStatus != Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                &&state.Assessment5FuelTypesStatus.Propane.dataReceivedStatus != Assessment3HHDataReceivedStatusEnum.NotMeetTarget
                )
                    && <span><strong>Looks good! No action needed!</strong></span>}

              <br/><br/>
              <h2>Assessment 4</h2>
              <br/><br/>
              <ol start={1}>
                  <li>
                      Do you have checks in place to examine whether agencies are collecting heating vendor information for every client? 
                      <br/>
                      <label>
                          <input type="radio"
                              name="checksCollectVendorInfoFlag"
                              id="checksCollectVendorInfoFlag_true"
                              value="true"
                              checked={state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === true}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checksCollectVendorInfoFlag"
                              id="checksCollectVendorInfoFlag_false"
                              value="false"
                              checked={state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === false}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === true
                        && <span><strong>Good!</strong></span>}
                      {state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === false
                        && <span>
                              <strong>Requires followup.</strong>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                  <li>
                      Do you have checks in place to review the data submitted by vendors and identify potential errors? 
                      <br/>
                      <label>
                          <input type="radio"
                              name="checksReviewDataSubmittedFlag"
                              id="checksReviewDataSubmittedFlag_true"
                              value="true"
                              checked={state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === true}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checksReviewDataSubmittedFlag"
                              id="checksReviewDataSubmittedFlag_false"
                              value="false"
                              checked={state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === false}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === true
                        && <span><strong>Good!</strong></span>}
                      {state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === false
                        && <span>
                              <strong>Requires followup.</strong>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                  <li>
                      Do you have procedures in place for reviewing and resolving the findings from your reliability checks?
                      <br/>
                      <label>
                          <input type="radio"
                              name="procedureReviewFindingsFlag"
                              id="procedureReviewFindingsFlag_true"
                              value="true"
                              checked={state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === true}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="procedureReviewFindingsFlag"
                              id="procedureReviewFindingsFlag_false"
                              value="false"
                              checked={state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === false}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === true
                        && <span><strong>Good!</strong></span>}
                      {state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === false
                        && <span>
                              <strong>Requires followup.</strong>
                              <br/>
                          </span>}
                      <br/>  
                  </li>
                  <li>
                      Do you have procedures in place for assessing the effectiveness of your checks and making changes when necessary?
                      <br/>
                      <label>
                          <input type="radio"
                              name="procedureAssessEffectivenessFlag"
                              id="procedureAssessEffectivenessFlag_true"
                              value="true"
                              checked={state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === true}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="procedureAssessEffectivenessFlag"
                              id="procedureAssessEffectivenessFlag_false"
                              value="false"
                              checked={state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === false}
                              onChange={(changeEvent) => state.assessment5HolderFieldChangeHandler(changeEvent)}
                          />
                          <span>No</span>
                      </label>
                      <br/ >
                      {state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === true
                        && <span><strong>Good!</strong></span>}
                      {state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === false
                        && <span>
                              <strong>Requires followup.</strong>
                              <br/>
                          </span>}
                      <br/>  
                  </li>

              </ol>

              {(state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === false
                    ||state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === false
                    ||state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === false
                    ||state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === false
                    )
                    &&<span>
                            <strong>Potential issue present! Follow-up required!</strong><br/>
                            Please conduct a full run-through of Assessment #4 to learn more about this potential
                            issue and ways you can address it.
                        </span>}
                  {(state.Assessment5FuelTypesStatus.checksCollectVendorInfoFlag === true
                    &&state.Assessment5FuelTypesStatus.checksReviewDataSubmittedFlag === true
                    &&state.Assessment5FuelTypesStatus.procedureReviewFindingsFlag === true
                    &&state.Assessment5FuelTypesStatus.procedureAssessEffectivenessFlag === true
                    )
                    && <span><strong>Looks good! No action needed!</strong></span>}
          </div>}
          
          {(state.CurrentAssessementStepIndex != Assessment5StepsEnum.checkEntry
            &&state.CurrentAssessementStepIndex != Assessment5StepsEnum.checkResult)
          &&
              <TableLegend />    
          }
    
          <button className="dataButton"
              onClick={() => state.assessment5ShowPreviousStep()}>
              Previous
          </button>
          {state.CurrentAssessementStepIndex < Assessment5StepsEnum.resultsOverview
          &&
              <button className="dataButton"
                  onClick={() => state.assessment5ShowNextStep()}
                  disabled={state.Assessment5ShowNextStepDisabled === true}>
                  Next
              </button>
          }

          {state.CurrentAssessementStepIndex < Assessment5StepsEnum.resultsOverview
          &&
              <button className="dataButton"
                  onClick={() => state.assessment5ShowActionPlan()}
                  disabled={state.Assessment5ShowNextStepDisabled === true}>
                  View Action Plan
              </button>
          }

          <br/>
          <button className="dataButton"
              onClick={() => state.backToStart()}>
              {state.CurrentAssessementStepIndex < Assessment5StepsEnum.resultsOverview
              &&<React.Fragment>Back to start</React.Fragment>}
              {state.CurrentAssessementStepIndex === Assessment5StepsEnum.resultsOverview
              &&<React.Fragment>Finish &amp; Save</React.Fragment>}
          </button>
          {state.CurrentAssessementStepIndex === Assessment5StepsEnum.resultsOverview
          &&
              <button className="dataButton"
                  onClick={() => window.print()}>
                  Print
              </button>
          }
          <div style={{clear:"both"}}>&nbsp;</div>



      </div>
    );

export default Assessment5;
